// Asset definition store — API-backed
const API = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5001`;

const authHeaders = () => {
  const token = localStorage.getItem('nrg-token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = 'Bearer ' + token;
  return headers;
};

const defaultDefinitions = [
  {
    id: 'solar',
    category: 'generation',
    name: 'Solar Plant',
    icon: '☀️',
    shape: { width: 160, height: 100 },
    frameColor: '#D4A843',
    connectorColor: '#D4A843',
    connectors: [
      { id: 'top-left', side: 'top', position: 0, enabled: true, favorite: false },
      { id: 'top-center', side: 'top', position: 1, enabled: true, favorite: true },
      { id: 'top-right', side: 'top', position: 2, enabled: true, favorite: false },
      { id: 'right-top', side: 'right', position: 0, enabled: true, favorite: false },
      { id: 'right-center', side: 'right', position: 1, enabled: true, favorite: true },
      { id: 'right-bottom', side: 'right', position: 2, enabled: true, favorite: false },
      { id: 'bottom-left', side: 'bottom', position: 0, enabled: true, favorite: false },
      { id: 'bottom-center', side: 'bottom', position: 1, enabled: true, favorite: true },
      { id: 'bottom-right', side: 'bottom', position: 2, enabled: true, favorite: false },
    ],
    maxSelectableConnectors: 3,
    fields: [
      { id: 'f1', name: 'capacity', label: 'Capacity', type: 'text', defaultValue: '100 kW', required: true },
      { id: 'f2', name: 'panel_type', label: 'Panel Type', type: 'select', options: ['Monocrystalline', 'Polycrystalline', 'Thin Film'], defaultValue: 'Monocrystalline', required: false },
      { id: 'f3', name: 'tilt_angle', label: 'Tilt Angle', type: 'number', defaultValue: '25', unit: '°', required: false },
      { id: 'f4', name: 'azimuth', label: 'Azimuth', type: 'number', defaultValue: '180', unit: '°', required: false },
      { id: 'f5', name: 'efficiency', label: 'Efficiency', type: 'number', defaultValue: '20', unit: '%', required: false },
      { id: 'f6', name: 'area', label: 'Area', type: 'number', defaultValue: '', unit: 'm²', required: false },
      { id: 'f7', name: 'inverter_capacity', label: 'Inverter Capacity', type: 'text', defaultValue: '', required: false },
      { id: 'f8', name: 'status', label: 'Status', type: 'select', options: ['active', 'inactive', 'planned', 'maintenance'], defaultValue: 'active', required: true },
    ],
  },
  {
    id: 'wind',
    category: 'generation',
    name: 'Wind Turbine',
    icon: '💨',
    shape: { width: 140, height: 120 },
    frameColor: '#4A90B8',
    connectorColor: '#4A90B8',
    connectors: [
      { id: 'top-left', side: 'top', position: 0, enabled: true, favorite: false },
      { id: 'top-center', side: 'top', position: 1, enabled: true, favorite: true },
      { id: 'top-right', side: 'top', position: 2, enabled: true, favorite: false },
      { id: 'right-top', side: 'right', position: 0, enabled: true, favorite: false },
      { id: 'right-center', side: 'right', position: 1, enabled: true, favorite: true },
      { id: 'right-bottom', side: 'right', position: 2, enabled: true, favorite: false },
      { id: 'bottom-left', side: 'bottom', position: 0, enabled: true, favorite: false },
      { id: 'bottom-center', side: 'bottom', position: 1, enabled: true, favorite: true },
      { id: 'bottom-right', side: 'bottom', position: 2, enabled: true, favorite: false },
    ],
    maxSelectableConnectors: 3,
    fields: [
      { id: 'f1', name: 'capacity', label: 'Capacity', type: 'text', defaultValue: '250 kW', required: true },
      { id: 'f2', name: 'hub_height', label: 'Hub Height', type: 'number', defaultValue: '80', unit: 'm', required: false },
      { id: 'f3', name: 'rotor_diameter', label: 'Rotor Diameter', type: 'number', defaultValue: '40', unit: 'm', required: false },
      { id: 'f4', name: 'cut_in_speed', label: 'Cut-in Speed', type: 'number', defaultValue: '3', unit: 'm/s', required: false },
      { id: 'f5', name: 'rated_speed', label: 'Rated Speed', type: 'number', defaultValue: '12', unit: 'm/s', required: false },
      { id: 'f6', name: 'cut_out_speed', label: 'Cut-out Speed', type: 'number', defaultValue: '25', unit: 'm/s', required: false },
      { id: 'f7', name: 'status', label: 'Status', type: 'select', options: ['active', 'inactive', 'planned', 'maintenance'], defaultValue: 'active', required: true },
    ],
  },
  {
    id: 'steam_turbine',
    category: 'generation',
    name: 'Steam Turbine',
    icon: '⚙️',
    shape: { width: 160, height: 110 },
    frameColor: '#f87171',
    connectorColor: '#f87171',
    connectors: [
      { id: 'top-left', side: 'top', position: 0, enabled: true, favorite: false },
      { id: 'top-center', side: 'top', position: 1, enabled: true, favorite: true },
      { id: 'top-right', side: 'top', position: 2, enabled: true, favorite: false },
      { id: 'right-top', side: 'right', position: 0, enabled: true, favorite: true },
      { id: 'right-center', side: 'right', position: 1, enabled: true, favorite: true },
      { id: 'right-bottom', side: 'right', position: 2, enabled: true, favorite: false },
      { id: 'bottom-left', side: 'bottom', position: 0, enabled: true, favorite: false },
      { id: 'bottom-center', side: 'bottom', position: 1, enabled: true, favorite: true },
      { id: 'bottom-right', side: 'bottom', position: 2, enabled: true, favorite: false },
    ],
    maxSelectableConnectors: 4,
    fields: [
      { id: 'f1', name: 'capacity', label: 'Capacity', type: 'number', defaultValue: '20', unit: 'MW', required: true },
      { id: 'f2', name: 'operating_mode', label: 'Operating Mode', type: 'select', options: ['Back-pressure', 'Condensing', 'Extraction-condensing', 'Extraction-back-pressure'], defaultValue: 'Condensing', required: true },
      { id: 'f3', name: 'steam_pressure', label: 'Steam Pressure', type: 'number', defaultValue: '103', unit: 'bar', required: true },
      { id: 'f4', name: 'steam_temperature', label: 'Steam Temperature', type: 'number', defaultValue: '505', unit: '°C', required: true },
      { id: 'f5', name: 'exhaust_pressure', label: 'Exhaust Pressure', type: 'number', defaultValue: '0.1', unit: 'bar', required: false },
      { id: 'f6', name: 'efficiency', label: 'Efficiency', type: 'number', defaultValue: '78', unit: '%', required: false },
      { id: 'f7', name: 'min_stable_load', label: 'Min Stable Load', type: 'number', defaultValue: '25', unit: '%', required: false },
      { id: 'f8', name: 'steam_flow_rate', label: 'Steam Flow Rate', type: 'number', defaultValue: '0', unit: 't/h', required: false },
      { id: 'f9', name: 'steam_source', label: 'Steam Source', type: 'select', options: ['Boiler (Coal)', 'Boiler (Gas)', 'Boiler (Biomass)', 'Waste Heat Recovery', 'Solar Thermal', 'Nuclear', 'Geothermal', 'Ammonia Plant', 'Nitric Acid Plant', 'Ammonia & Nitric Acid Plant'], required: false },
      { id: 'f10', name: 'status', label: 'Status', type: 'select', options: ['active', 'inactive', 'planned', 'maintenance'], defaultValue: 'active', required: true },
    ],
  },
  {
    id: 'hot_gas_generator',
    category: 'conversion',
    name: 'Hot Gas Generator',
    icon: '♨️',
    shape: { width: 160, height: 110 },
    frameColor: '#f59e0b',
    connectorColor: '#f59e0b',
    connectors: [
      { id: 'top-left', side: 'top', position: 0, enabled: true, favorite: false },
      { id: 'top-center', side: 'top', position: 1, enabled: true, favorite: true },
      { id: 'top-right', side: 'top', position: 2, enabled: true, favorite: false },
      { id: 'right-top', side: 'right', position: 0, enabled: true, favorite: false },
      { id: 'right-center', side: 'right', position: 1, enabled: true, favorite: true },
      { id: 'right-bottom', side: 'right', position: 2, enabled: true, favorite: false },
      { id: 'bottom-left', side: 'bottom', position: 0, enabled: true, favorite: false },
      { id: 'bottom-center', side: 'bottom', position: 1, enabled: true, favorite: true },
      { id: 'bottom-right', side: 'bottom', position: 2, enabled: true, favorite: false },
    ],
    maxSelectableConnectors: 4,
    fields: [
      { id: 'f1', name: 'thermal_capacity', label: 'Thermal Capacity', type: 'number', defaultValue: '10', unit: 'MW_th', required: true },
      { id: 'f2', name: 'fuel_type', label: 'Fuel Type', type: 'select', options: ['Coal', 'Anthracite', 'Petcoke', 'Biomass', 'RDF', 'Natural Gas'], defaultValue: 'Anthracite', required: true },
      { id: 'f3', name: 'fuel_calorific_value', label: 'Fuel Calorific Value', type: 'number', defaultValue: '27', unit: 'MJ/kg', required: true },
      { id: 'f4', name: 'fuel_consumption', label: 'Fuel Consumption', type: 'number', defaultValue: '0', unit: 't/h', required: false },
      { id: 'f5', name: 'hot_gas_temperature', label: 'Hot Gas Temperature', type: 'number', defaultValue: '900', unit: '°C', required: true },
      { id: 'f6', name: 'hot_gas_flow_rate', label: 'Hot Gas Flow Rate', type: 'number', defaultValue: '0', unit: 'Nm³/h', required: false },
      { id: 'f7', name: 'thermal_efficiency', label: 'Thermal Efficiency', type: 'number', defaultValue: '90', unit: '%', required: false },
      { id: 'f8', name: 'parasitic_load', label: 'Parasitic Load', type: 'number', defaultValue: '50', unit: 'kW', required: false },
      { id: 'f9', name: 'min_stable_load', label: 'Min Stable Load', type: 'number', defaultValue: '30', unit: '%', required: false },
      { id: 'f10', name: 'status', label: 'Status', type: 'select', options: ['active', 'inactive', 'planned', 'maintenance'], defaultValue: 'active', required: true },
    ],
  },
];

// Ensure all definitions have 12 connectors (3 per side)
export const ensureConnectors = (def) => {
  const sides = ['top', 'right', 'bottom', 'left'];
  const needed = [];
  sides.forEach((side) => {
    for (let p = 0; p < 3; p++) {
      const id = `${side}-${['left', 'center', 'right'][p]}`.replace(
        /^(right|left)-(left|center|right)$/,
        (_, s, pos) => `${s}-${['top', 'center', 'bottom'][p]}`
      );
      const realId = `${side}-${p}`;
      const existing = def.connectors?.find((c) => c.id === realId || c.side === side && c.position === p);
      if (existing) {
        needed.push({ ...existing, side, position: p, id: realId });
      } else {
        needed.push({ id: realId, side, position: p, enabled: true, favorite: false });
      }
    }
  });
  return { ...def, connectors: needed };
};

// Merge API response {id, category, name, definition} into flat object
const mergeDefinition = (apiDef) => {
  const { definition, ...top } = apiDef;
  return { ...top, ...(definition || {}) };
};

// Split a flat definition into API shape {id, category, name, definition}
const splitDefinition = (def) => {
  const { id, category, name, ...rest } = def;
  return { id, category, name, definition: rest };
};

export async function loadDefinitions() {
  try {
    const res = await fetch(`${API}/api/asset-definitions`, { headers: authHeaders() });
    if (res.ok) {
      const data = await res.json();
      const arr = Array.isArray(data) ? data : (data.definitions || []);
      if (arr.length > 0) {
        return arr.map(mergeDefinition).map(ensureConnectors);
      }
    }
  } catch (err) {
    console.warn('Failed to load asset definitions from API, using defaults:', err.message);
  }
  // Fallback to defaults if API is unreachable or empty
  return defaultDefinitions.map(ensureConnectors);
}

export async function updateDefinition(id, updates) {
  try {
    const { id: _id, ...rest } = updates;
    const { category, name, ...defBody } = rest;
    const body = { definition: defBody };
    if (category !== undefined) body.category = category;
    if (name !== undefined) body.name = name;
    const res = await fetch(`${API}/api/asset-definitions/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(body),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function createDefinition(def) {
  try {
    const payload = splitDefinition(ensureConnectors(def));
    const res = await fetch(`${API}/api/asset-definitions`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function deleteDefinition(id) {
  try {
    const res = await fetch(`${API}/api/asset-definitions/${id}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    return res.ok;
  } catch {
    return false;
  }
}

// Save a full definition (used by editor — does PUT with the entire object)
export async function saveDefinition(def) {
  const payload = splitDefinition(def);
  try {
    const res = await fetch(`${API}/api/asset-definitions/${def.id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export const CATEGORIES = [
  { id: 'generation',     label: 'Generation',     color: '#D4A843' },
  { id: 'storage',        label: 'Storage',        color: '#4ecca3' },
  { id: 'conversion',     label: 'Conversion',     color: '#ec4899' },
  { id: 'process',        label: 'Process',        color: '#a855f7' },
  { id: 'consumption',    label: 'Consumption',    color: '#7B68AE' },
  { id: 'infrastructure', label: 'Infrastructure', color: '#F97316' },
  { id: 'grid',           label: 'Grid',           color: '#f87171' },
];
